"use client";

import { useContext, useEffect, useMemo } from "react";
import styles from './_hcp-header-nav.module.scss';
import { renderToString } from 'react-dom/server';
import { NavLink } from "@/components/nav-link";
import CustomImage from "@/components/image";
import { LayoutContext } from "@/components/layout-context-container";
import { headerNavegationHcpItems } from "@/data/navigation-hcp";
import HcpUtilNav from "../util-nav";
import { useRouter } from "next/router";
import { lockScroll, unlockScroll } from "@/util/scrollLock";

export default function HcpHeaderNav({mobile = false, customClass = undefined, ...rest}) {
  const router = useRouter();
  const { showMobileMenu, setShowMobileMenu, setAutoScrollActive } = useContext(LayoutContext);

  const containerClass = useMemo(() => {
    var className = styles.container;

    if (showMobileMenu) {
      className = `${className} ${styles.menu_show} header--mobile-menu-showing`;
    }

    if (mobile) {
      className = `${className} ${styles.mobile}`;
    }

    if (customClass) {
      className = `${className} ${customClass}`;
    }

    return className;
  }, [showMobileMenu, mobile, customClass]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth >= 1024) {
        // auto close mobile menu if opened from desktop and screen becomes larger than tablet size
        setShowMobileMenu(false);
      }
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [setShowMobileMenu]);

  useEffect(() => {
    // disable page scroll if mobile menu is open
    if (showMobileMenu) {
      lockScroll('mobile-nav');
    } else {
      unlockScroll('mobile-nav');
    }

    return () => unlockScroll('mobile-nav');
  }, [showMobileMenu]);

  function handleShowHideMobileMenu() {
    setShowMobileMenu(!showMobileMenu);
  }

  function handleNavClick() {
    mobile && setShowMobileMenu(false);
  }
  
  return (
    <nav className={containerClass} {...rest}>
      {!mobile && <div className={styles.util_nav}>
        <span className={styles.message}>
          This site is intended for US healthcare professionals only.
        </span>
        <HcpUtilNav /> 
      </div>}
      <div className={styles.items}>
        {headerNavegationHcpItems.map(({headerNavLabel, path, leaveSiteLink, externalLink}, i) => (
          <NavLink
            key={`key_hcp-header_nav_item_${i}`}
            href={path}
            onClick={handleNavClick}
            leaveSiteLink={leaveSiteLink}
            externalLink={externalLink}
            activeClass={styles.active}
            data-gtm-event-category="Top Navigation"
            data-gtm-event-action="Click"
            data-gtm-event-label={renderToString(headerNavLabel)}
          >
            {headerNavLabel}
          </NavLink>
        ))}
        {mobile && <HcpUtilNav />}
      </div>
      {!mobile && <div className={styles.button_mobile_menu}>
        <button
          type="button"
          onClick={handleShowHideMobileMenu}
        >
        {!showMobileMenu
          ? <CustomImage
              src="/images/icons/icon-hcp-menu-mobile.svg"
              width={38}
              height={38}
              alt="Open menu"
              data-gtm-event-category="Top Navigation"
              data-gtm-event-action="Click"
              data-gtm-event-label="Menu button"
            />
          : <CustomImage
              src="/images/icons/icon-hcp-menu-mobile-close.svg"
              width={38}
              height={38}
              alt="Close menu"
              data-gtm-event-category="Top Navigation"
              data-gtm-event-action="Click"
              data-gtm-event-label="Menu Close"
            />}
        </button>
      </div>}
    </nav>
  );
}